import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, Typography } from '@chilecompra/react-kit/components'
import { DialogWrapper, DivIcon } from './QuoteBid.styles'

/**
 * The Quote Bid information dialog's component.
 */
const QuoteBidSecondCallDialog = props => {
  const { handleSecondCallClose, handleClick, open } = props
  return (
    <Dialog open={open} onClose={handleSecondCallClose} verticalAlign="top">
      <DialogWrapper>
        <DivIcon>
          <Typography style={{ color: '#007bff', fontSize: '30px', fontWeight: 'bold' }}>!</Typography>
        </DivIcon>
        <Typography align="center" fontSize="18px" fontWeight="bold" lineHeight="22px" margin="10px 10px" variant="h4">
          ¿Deseas realizar un segundo llamado <br /> para tu Compra Ágil?
        </Typography>
        <br />
        <Typography align="center" fontSize="14px" lineHeight="18px" variant="body2">
          Al realizar el segundo llamado de tu Compra Ágil, todas las empresas <br />
          proveedoras podrán participar. Este segundo llamado se publicará con el <br />
          mismo plazo original.
        </Typography>
        <br />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
          <Button
            color="primary"
            style={{
              marginTop: '15px',
              marginBottom: '10px',
              width: '260px', // Fuerza el mismo ancho
              padding: '10px 0' // Asegura altura uniforme
            }}
            onClick={handleClick}
            type="button"
            variant="contained"
          >
            Realizar segundo llamado
          </Button>

          <Button
            onClick={handleSecondCallClose}
            type="button"
            variant="outlined"
            style={{
              width: '260px', // Igual que el otro botón
              padding: '10px 0' // Misma altura
            }}
          >
            Cerrar
          </Button>
        </div>
      </DialogWrapper>
    </Dialog>
  )
}

QuoteBidSecondCallDialog.propTypes = {
  handleSecondCallClose: PropTypes.func,
  handleClick: PropTypes.func,
  open: PropTypes.bool
}

export default QuoteBidSecondCallDialog
